export default {
  permisos: (state) => state.permisos,
  isMobile: (state) => (state.isMobile ?? false),
};
